import { useLocation, useNavigate } from 'react-router-dom';
import LanguageSwitcher from '@/common/components/languageSwitcher/LanguageSwitcher';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { isAuthenticated, useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { REGISTRATION_SOURCE } from '@/common/functions/getUtms';
import {
	ChatNavIcon,
	DiscoverIcon,
	LoungeIcon,
	MySoftiesIcon,
	StudioIcon,
} from '../../icons/NavIcons';
import {
	NavButton,
	NavIcon,
	NavLabel,
	SideNav,
	Sidebar,
	SidebarLanguageSlot,
} from './SidebarMenu.styles';

const NAV_ITEMS = [
	{ id: 'home', labelKey: 'lounge', path: '/', match: (p) => p === '/' || p === '', guestAllowed: true },
	{
		id: 'discover',
		labelKey: 'discover',
		path: '/discover',
		match: (p) => p === 'discover',
		guestAllowed: true,
	},
	{ id: 'chat', labelKey: 'chat', path: '/chat', match: (p) => p === 'chat', guestAllowed: false, authTab: 'register' },
	{
		id: 'studio',
		labelKey: 'studio',
		path: '/studio',
		match: (p) => p === 'studio',
		guestAllowed: true,
	},
	{
		id: 'mine',
		labelKey: 'mySofties',
		path: '/my-softies',
		match: (p) => p === 'my-softies',
		guestAllowed: true,
	},
];

const SidebarMenu = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const t = useLanguageData('nav');
	const { openAuthModal } = useGuestAuth();
	const segment = location.pathname.split('/')[1] || '';
	const guest = !isAuthenticated();

	const handleNavigate = (item) => {
		if (guest && !item.guestAllowed) {
			const registrationSource =
				item.id === 'chat' ? REGISTRATION_SOURCE.CHAT : null;

			openAuthModal(item.authTab ?? 'register', item.path, registrationSource);
			return;
		}
		navigate(item.path);
	};

	return (
		<Sidebar aria-label={t.mainNavigation}>
			<SideNav>
				{NAV_ITEMS.map((item) => {
					const active = item.match(segment);
					const label = t[item.labelKey];
					return (
						<NavButton
							key={item.id}
							type="button"
							$active={active}
							title={label}
							aria-label={label}
							aria-current={active ? 'page' : undefined}
							onClick={() => handleNavigate(item)}
						>
							<NavIcon aria-hidden="true">
								{item.id === 'home' && <LoungeIcon />}
								{item.id === 'discover' && <DiscoverIcon />}
								{item.id === 'chat' && <ChatNavIcon />}
								{item.id === 'studio' && <StudioIcon />}
								{item.id === 'mine' && <MySoftiesIcon />}
							</NavIcon>
							<NavLabel>{label}</NavLabel>
						</NavButton>
					);
				})}
			</SideNav>
			<SidebarLanguageSlot>
				<LanguageSwitcher />
			</SidebarLanguageSlot>
		</Sidebar>
	);
};

export default SidebarMenu;
